import { Tabs } from "antd";
import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import PPPageHeader from "../../components/pageHeader/PPPageHeader";
import InventoryListItem from "./InventoryListItem";
import PalletListItem from "./PalletListItem";

const ALL_TABS = [
  { key: "inventory", label: "Тооллого" },
  { key: "pallet", label: "Тавиурын бүртгэл" },
];

const List = () => {
  const history = useHistory();
  const location = useLocation();

  const initialTab =
    new URLSearchParams(location.search).get("tab") || ALL_TABS[0].key;
  const getValidKey = (key) =>
    ALL_TABS.find((item) => item.key === key) ? key : ALL_TABS[0].key;

  const [currentKey, setCurrentKey] = useState(() => getValidKey(initialTab));

  const onChange = (key) => {
    setCurrentKey(key);
    history.replace({
      pathname: location.pathname,
      search: `?tab=${key}`,
      state: location.state,
    });
  };

  return (
    <div>
      <PPPageHeader title="Тооллого" />
      <Tabs
        activeKey={currentKey}
        onChange={onChange}
        items={ALL_TABS}
        tabBarStyle={{ marginBottom: 0, margin: "0", padding: "0 12px" }}
      />

      {/* Таб бүр эргэн тойрны зайгаа өөрөө агуулна тул wrapper-гүй */}
      {currentKey === "inventory" && <InventoryListItem />}
      {currentKey === "pallet" && <PalletListItem />}
    </div>
  );
};

export default List;
